import React, { useEffect } from 'react'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'

import PropTypes from 'prop-types'

import { MapContainer } from './map.component.styles'
import { getMapCenter, getDefaultZoom } from '../../service/map.service'
import PickupPin from './asset/pick-up.svg'
import DropoffPin from './asset/drop-off.svg'

const Map = ({ pickupCoordinate, dropoffCoordinate }) => {
  const mapCenter = getMapCenter()
  const defaultZoom = getDefaultZoom()

  const mapStyles = [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        { visibility: 'off' }
      ]
    },
  ]

  const { protocol, hostname, port } = window.location

  const protocolHostname = `${protocol}//${hostname}${port ? `:${port}` : ''}`
  const pickUpPinURL = protocolHostname + PickupPin
  const dropoffPinURL = protocolHostname + DropoffPin

  const mapRef = React.useRef(null)

  useEffect(() => {
    if (!window.google) return

    const singlePinZoom = 17

    if(pickupCoordinate && dropoffCoordinate) {
      const bounds = new window.google.maps.LatLngBounds()

      bounds.extend({ lat: pickupCoordinate.latitude, lng: pickupCoordinate.longitude })
      bounds.extend({ lat: dropoffCoordinate.latitude, lng: dropoffCoordinate.longitude })

      mapRef.current.fitBounds(bounds)
    } else if( pickupCoordinate ) {
      mapRef.current.setCenter({ lat: pickupCoordinate.latitude, lng: pickupCoordinate.longitude })
      mapRef.current.setZoom(singlePinZoom)
    } else if( dropoffCoordinate ) {
      mapRef.current.setCenter({ lat: dropoffCoordinate.latitude, lng: dropoffCoordinate.longitude })
      mapRef.current.setZoom(singlePinZoom)
    } else if (mapRef.current !== null) {
      mapRef.current.setZoom(defaultZoom)
    }
  }, [pickupCoordinate, dropoffCoordinate, defaultZoom])

  return (
    <MapContainer>
      <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}>
        <GoogleMap
          center={mapCenter}
          mapContainerStyle={{
            height: '100%',
            width: '100%'
          }}
          zoom={defaultZoom}
          options={{
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            styles: mapStyles,
          }}
          onLoad={map => {
            mapRef.current = map
          }}
        >
          {
            pickupCoordinate && (
              <Marker
                position={{
                  lat: pickupCoordinate.latitude,
                  lng: pickupCoordinate.longitude,
                }}
                icon={pickUpPinURL}
              />
            )
          }
          {
            dropoffCoordinate && (
              <Marker
                position={{
                  lat: dropoffCoordinate.latitude,
                  lng: dropoffCoordinate.longitude,
                }}
                icon={dropoffPinURL}
              />
            )
          }

        </GoogleMap>
      </LoadScript>
    </MapContainer>
  )
}

const propTypesShape = PropTypes.shape({
  latitude: PropTypes.number,
  longitude: PropTypes.number
})

Map.propTypes = {
  pickupCoordinate: propTypesShape,
  dropoffCoordinate: propTypesShape,
}

Map.defaultProps = {
  pickupCoordinate: null,
  dropoffCoordinate: null
}

const MemoMap = React.memo(Map)

export { MemoMap }
